// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import CreateNewProfessionalModal from './data'

export default function CreateNewProfessionalModalFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/CreateNewProfessionalModal">
      <CreateNewProfessionalModal {...props}>
        {children}
      </CreateNewProfessionalModal>
    </Flow>
  )
}
